var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite_icon_container",on:{"click":_vm.toggleStar}},[(_vm.isFavorite)?_c('i',{staticClass:"zmdi zmdi-star"}):_c('i',{staticClass:"zmdi zmdi-star-outline"})])}
var staticRenderFns = []

export { render, staticRenderFns }